import React from 'react';
import PropTypes from 'prop-types';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { AllhomesArticleWrapper } from '@domain-group/fe-co-allhomes-article-card';
import { articleProps } from '../common-props';
import * as styles from './agency-articles.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgencyArticles = _ref => {
  var articles = _ref.articles,
    layout = _ref.layout;
  return ___EmotionJSX("div", {
    css: styles.agencyArticles
  }, ___EmotionJSX("h3", {
    css: styles.title
  }, "In the news"), ___EmotionJSX(EventBoundary, {
    name: "agency-articles"
  }, ___EmotionJSX(AllhomesArticleWrapper, {
    layout: layout,
    articles: articles.map(article => {
      var _article$tags, _article$tags$;
      return {
        description: article.title,
        image: article.image,
        url: article.url,
        tags: [(_article$tags = article.tags) === null || _article$tags === void 0 ? void 0 : (_article$tags$ = _article$tags[0]) === null || _article$tags$ === void 0 ? void 0 : _article$tags$.label],
        target: '_blank',
        rel: 'noopener'
      };
    })
  })));
};
AgencyArticles.propTypes = {
  articles: PropTypes.arrayOf(articleProps),
  layout: PropTypes.oneOf(['row', 'column', 'two-row'])
};
AgencyArticles.defaultProps = {
  articles: [],
  layout: 'column'
};
export default AgencyArticles;